import { AppTheme } from "./AppTheme";
import { useAppContext } from "../ctx/MyContext";


export const useAppTheme =(): AppTheme =>
    useAppContext().app.store.settings.branding.theme
